import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ledProduct.css';

const SLIDE_INTERVAL = 4000;

const LedProduct = () => {
    const introImages = [
        '/images/product/led/led.jpg',
        '/images/product/led/led1.jpg',
        '/images/product/led/led2.jpg',
        '/images/product/led/led3.jpg',
        '/images/product/led/led4.jpg',
    ];

    const [introIndex, setIntroIndex] = useState(0);

    useEffect(() => {
        if (introImages.length <= 1) {
            return;
        }

        const interval = setInterval(() => {
            setIntroIndex((prevIndex) =>
                (prevIndex + 1) % introImages.length
            );
        }, SLIDE_INTERVAL);

        return () => clearInterval(interval);
    }, [introImages.length]);

    const selectedIntroImage = introImages[introIndex];

    const products = [
        {
            id: '2mm',
            pitch: '2mm PIXEL PITCH',
            title: '2mm 실내용 LED 전광판',
            type: '실내용',
            description:
                '2mm 픽셀 간격을 갖춘 고해상도 LED 전광판은 가까운 거리에서도 세밀하고 선명한 화면을 표현할 수 있습니다. 실내 행사에 최적의 밝기와 높은 해상도를 제공하며 세미나, 발표회, 학술대회, 광고 촬영 등 선명한 영상 표현이 필요한 공간에 적합합니다.',
            tags: [
                '세미나',
                '발표회',
                '학술대회',
                '광고 촬영'
            ],
            images: [
                '/images/product/led/led-2mm-01.jpg',
                '/images/product/led/led-2mm-02.jpg',
                '/images/product/led/led-2mm-03.jpg'
            ]
        },
        {
            id: '3mm',
            pitch: '3mm PIXEL PITCH',
            title: '3mm 실내용 LED 전광판',
            type: '실내용',
            description:
                '3mm 픽셀 간격을 갖춘 LED 전광판은 선명한 화질과 뛰어난 활용성을 제공하는 실내용 제품입니다. 작은 글자와 섬세한 화면 표현이 필요한 환경에서도 높은 시인성을 제공하며 각종 행사, 전시, 세미나 및 발표 공간에 다양하게 활용할 수 있습니다.',
            tags: [
                '기업행사',
                '전시',
                '세미나',
                '발표회'
            ],
            images: [
                '/images/product/led/led-3mm-01.jpg',
                '/images/product/led/led-3mm-02.jpg',
                '/images/product/led/led-3mm-03.jpg'
            ]
        },
        {
            id: '4mm',
            pitch: '4mm PIXEL PITCH',
            title: '4mm 실내·실외용 LED 전광판',
            type: '실내 · 실외용',
            description:
                '4mm 픽셀 간격을 갖춘 LED 전광판은 높은 밝기가 필요한 야외 환경에 적합합니다. 자연광이 있는 실외에서도 높은 시인성을 제공하며 현장 환경에 따라 실내에서도 밝기를 조절하여 사용할 수 있습니다. 공연, 축제, 발표회 등 대형 화면과 높은 광량이 필요한 행사에 적합합니다.',
            tags: [
                '공연',
                '축제',
                '야외행사',
                '발표회'
            ],
            images: [
                '/images/product/led/led-4mm-01.jpg',
                '/images/product/led/led-4mm-02.jpg',
                '/images/product/led/led-4mm-03.jpg'
            ]
        }
    ];

    return (
        <>
            <main className="led-product-page">

                {/* SUB VISUAL */}
                <section className="led-sub-visual">
                    <div className="led-sub-overlay"></div>

                    <div className="led-sub-inner">
                        <p>PRODUCT</p>

                        <h1>LED 전광판</h1>

                        <div className="led-breadcrumb">
                            <Link to="/">
                                HOME
                            </Link>

                            <span>›</span>
                            <span>제품소개</span>
                            <span>›</span>

                            <strong>
                                LED 전광판
                            </strong>
                        </div>
                    </div>
                </section>

                {/* INTRO */}
                <section className="led-intro-section">
                    <div className="led-container">

                        <div className="led-section-heading">
                            <p>LED DISPLAY</p>

                            <h2>
                                공간과 목적에 맞는
                                <br />
                                <strong>
                                    LED 전광판
                                </strong>
                            </h2>

                            <span className="led-title-line"></span>
                        </div>

                        <div className="led-intro-content">

                            {/* INTRO GALLERY */}
                            <div className="led-intro-gallery">

                                <div className="led-intro-image">
                                    <img
                                        key={selectedIntroImage}
                                        src={selectedIntroImage}
                                        alt="LED 전광판"
                                    />

                                    <div className="led-intro-image-label">
                                        <span>
                                            MTMEDIA
                                        </span>

                                        <strong>
                                            LED DISPLAY
                                        </strong>
                                    </div>
                                </div>

                                {introImages.length > 1 && (
                                    <div className="led-intro-thumbnails">
                                        <div
                                            className="led-intro-thumbnail-track"
                                            style={{
                                                transform: `translateX(-${
                                                    Math.max(0, introIndex - 2) * (100 / 3)
                                                }%)`
                                            }}
                                        >
                                            {introImages.map((image, index) => (
                                                <button
                                                    type="button"
                                                    key={image}
                                                    className={
                                                        introIndex === index
                                                            ? 'led-intro-thumbnail active'
                                                            : 'led-intro-thumbnail'
                                                    }
                                                    onClick={() => setIntroIndex(index)}
                                                    aria-label={`LED 전광판 이미지 ${index + 1}`}
                                                >
                                                    <img
                                                        src={image}
                                                        alt={`LED 전광판 ${index + 1}`}
                                                    />
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* INTRO TEXT */}
                            <div className="led-intro-text">

                                <p className="led-small-title">
                                    LED 전광판이란?
                                </p>

                                <h3>
                                    선명한 화면으로
                                    <br />
                                    공간의 가치를 높입니다.
                                </h3>

                                <p>
                                    LED 전광판은 각각의 LED 소자가
                                    직접 빛을 내어 영상을 표현하는
                                    디스플레이입니다. 높은 밝기와
                                    뛰어난 시인성을 제공하며 설치
                                    장소와 사용 목적에 따라
                                    실내용·실외용 제품을 선택할 수
                                    있습니다.
                                </p>

                                <p>
                                    엠티미디어는 행사 환경과
                                    시청거리를 고려하여 적합한 픽셀
                                    피치와 화면 크기를 제안하고,
                                    장비 구성부터 설치 및 운영까지
                                    전문적으로 지원합니다.
                                </p>

                                <div className="led-intro-point">

                                    <div>
                                        <strong>
                                            Indoor
                                        </strong>
                                        <span>
                                            실내용
                                        </span>
                                    </div>

                                    <div>
                                        <strong>
                                            Outdoor
                                        </strong>
                                        <span>
                                            실외용
                                        </span>
                                    </div>

                                    <div>
                                        <strong>
                                            2mm - 4mm
                                        </strong>
                                        <span>
                                            다양한 픽셀 피치
                                        </span>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </section>

                {/* RENTAL GUIDE */}
                <section className="led-guide-section">
                    <div className="led-container">

                        <div className="led-guide-heading">
                            <p>
                                RENTAL GUIDE
                            </p>

                            <h2>
                                LED 전광판 대여 · 렌탈 시 고려사항
                            </h2>

                            <span>
                                행사 환경과 사용 목적에 따라
                                적합한 제품을 선택하는 것이
                                중요합니다.
                            </span>
                        </div>

                        <div className="led-guide-list">

                            <div className="led-guide-card">
                                <span className="led-guide-number">
                                    01
                                </span>

                                <div className="led-guide-icon">
                                    <i className="mdi mdi-home-city-outline"></i>
                                </div>

                                <h3>
                                    설치 환경
                                </h3>

                                <p>
                                    장소에 따라 실내용·실외용
                                    제품을 구분하고 현장의 밝기와
                                    설치 환경에 적합한 제품을
                                    선택해야 합니다.
                                </p>
                            </div>

                            <div className="led-guide-card">
                                <span className="led-guide-number">
                                    02
                                </span>

                                <div className="led-guide-icon">
                                    <i className="mdi mdi-weather-rainy"></i>
                                </div>

                                <h3>
                                    방수 · 방진
                                </h3>

                                <p>
                                    실외 행사에서는 날씨와 외부
                                    환경의 영향을 고려하여
                                    방수·방진 규격에 적합한 장비를
                                    사용하는 것이 중요합니다.
                                </p>
                            </div>

                            <div className="led-guide-card">
                                <span className="led-guide-number">
                                    03
                                </span>

                                <div className="led-guide-icon">
                                    <i className="mdi mdi-monitor-eye"></i>
                                </div>

                                <h3>
                                    픽셀 피치 · 가시거리
                                </h3>

                                <p>
                                    화면 크기와 시청거리를
                                    고려하여 적절한 픽셀 피치를
                                    선택하면 더욱 선명하고 편안한
                                    화면을 구현할 수 있습니다.
                                </p>
                            </div>

                        </div>
                    </div>
                </section>

                {/* PRODUCTS */}
                <section className="led-products-section">
                    <div className="led-container">

                        <div className="led-products-heading">
                            <p>
                                LED PRODUCTS
                            </p>

                            <h2>
                                LED 전광판 제품
                            </h2>

                            <span>
                                행사 규모와 설치 환경에 맞는
                                제품을 선택해보세요.
                            </span>
                        </div>

                        <div className="led-products-list">
                            {products.map(
                                (product, index) => (
                                    <LedProductItem
                                        key={product.id}
                                        product={product}
                                        reverse={
                                            index % 2 !== 0
                                        }
                                    />
                                )
                            )}
                        </div>

                    </div>
                </section>

                {/* CONTACT */}
                <section className="led-contact-section">
                    <div className="led-contact-overlay"></div>
                    <div className="led-contact-inner">
                        <p>MTMEDIA CONSULTING</p>

                        <h2>어떤 LED 전광판이<br />적합한지 고민되시나요?</h2>

                        <span>
                            행사 장소와 규모, 사용 목적을
                            알려주시면
                            <br />
                            현장에 적합한 LED 전광판을
                            안내해드립니다.
                        </span>

                        <Link
                            to="/inquiry"
                            className="led-contact-button"
                        >
                            견적문의 하기
                            <i className="mdi mdi-arrow-right"></i>
                        </Link>
                    </div>
                </section>
            </main>
        </>
    );
};


/* =========================================================
   LED PRODUCT ITEM
========================================================= */
const LedProductItem = ({ product, reverse }) => {
    const [imageIndex, setImageIndex] = useState(0);

    useEffect(() => {
        if (product.images.length <= 1) {
            return;
        }

        const interval = setInterval(() => {
            setImageIndex((prevIndex) =>
                (prevIndex + 1) % product.images.length
            );
        }, SLIDE_INTERVAL);

        return () => clearInterval(interval);
    }, [product.images.length]);

    const selectedImage = product.images[imageIndex];

    return (
        <article
            className={`led-product-item ${
                reverse ? 'reverse' : ''
            }`}
        >

            {/* PRODUCT GALLERY */}
            <div className="led-product-gallery">

                <div className="led-product-main-image">
                    <img
                        key={selectedImage}
                        src={selectedImage}
                        alt={product.title}
                    />
                </div>

                {product.images.length > 1 && (
                    <div className="led-product-thumbnails">
                        <div
                            className="led-product-thumbnail-track"
                            style={{
                                transform: `translateX(-${
                                    Math.max(0, imageIndex - 2) * (100 / 3)
                                }%)`
                            }}
                        >
                            {product.images.map((image, index) => (
                                <button
                                    type="button"
                                    key={image}
                                    className={
                                        imageIndex === index
                                            ? 'led-thumbnail active'
                                            : 'led-thumbnail'
                                    }
                                    onClick={() => setImageIndex(index)}
                                    aria-label={`${product.title} 이미지 ${index + 1}`}
                                >
                                    <img
                                        src={image}
                                        alt=""
                                    />
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* PRODUCT INFO */}
            <div className="led-product-info">

                <div className="led-product-type">
                    {product.type}
                </div>

                <p className="led-product-pitch">
                    {product.pitch}
                </p>

                <h3>
                    {product.title}
                </h3>

                <div className="led-product-line"></div>

                <p className="led-product-description">
                    {product.description}
                </p>

                <div className="led-product-tags">
                    {product.tags.map((tag) => (
                        <span key={tag}>
                            {tag}
                        </span>
                    ))}
                </div>

                <Link
                    to="/inquiry"
                    className="led-product-inquiry"
                >
                    렌탈 문의
                    <i className="mdi mdi-arrow-right"></i>
                </Link>

            </div>

        </article>
    );
};

export default LedProduct;